import { connect } from 'react-redux';
import {
  getContract,
  getAuth,
  getContracts,
  exportContract,
  validateMapping,
  login,
  updateSettingsAction,
  saveSettingsAction,
  getSettings,
  updateWithKeyPath,
  changeExportType,
  sendHistoryFeedMsg,
  updateMapping,
} from '../../stores/integration/integration-actions';
import React, { Component, cloneElement, PropTypes } from 'react';

class IntegrationContainer extends Component {

  constructor(props) {
    super(props);
    this._getRouteName = this._getRouteName.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getSettings());
  }
  _getRouteName() {
    const { location } = this.props;
    if (location.pathname.indexOf('product-mapping') > 0) return 'product-mapping';
  }

  _getContractID() {
    const { location, params } = this.props;
    if (location.pathname.indexOf('product-mapping') > 0) return params.contractID;
  }

  changeExportType = payload => this.props.dispatch(changeExportType(payload));

  render() {
    const { children, ...props } = this.props;
    const routeName = this._getRouteName();
    const contractID = this._getContractID();
    const extraProps = {
      routeName,
      contractID,
      changeExportType: this.changeExportType,
      login: (userName, password, url) => props.dispatch(login(userName, password, url)),
      ...props,
    };
    return (
      <div>
        {children ? cloneElement(children, extraProps) : undefined}
      </div>
    );
  }

}

IntegrationContainer.propTypes = {
  location: PropTypes.object,
  dispatch: PropTypes.func,
  params: PropTypes.object,
  integration: PropTypes.object,
  children: PropTypes.object,
  history: PropTypes.object,
};

const select = (state) => {
  return {
    integration: state.integration.toJS(),
  };
};

const mapDispatchToProps = dispatch => ({
  updateSettings: payload => dispatch(updateSettingsAction(payload)),
  saveSettings: (...args) => dispatch(saveSettingsAction(...args)),
  updateWithKeyPath: (...args) => dispatch(updateWithKeyPath(...args)),
  sendMsg: (...args) => dispatch(sendHistoryFeedMsg(...args)),
  getContract: (contractId) => dispatch(getContract(contractId)),
  getContracts: payload => dispatch(getContracts(payload)),
  getAuth: () => dispatch(getAuth()),
  exportContract: (...args) => dispatch(exportContract(...args)),
  validateMapping: (...args) => dispatch(validateMapping(...args)),
  updateMapping: (...args) => dispatch(updateMapping(...args))
});

export default connect(select, mapDispatchToProps)(IntegrationContainer);



// WEBPACK FOOTER //
// ./src/app/components/integration/integrationContainer.jsx